import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

// Helper to determine card styles based on status
export const getStatusCardStyles = (status) => {
    switch (status?.toLowerCase()) {
        case "available":
            return "bg-green-50 border-green-200 text-green-700 dark:bg-green-900/20 dark:border-green-800 dark:text-green-400";
        case "allocate":
        case "allocated":
            return "bg-orange-50 border-orange-200 text-orange-700 dark:bg-orange-900/20 dark:border-orange-800 dark:text-orange-400";
        case "occupied":
            return "bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-400";
        case "pay & park":
        case "pay_and_park":
            return "bg-purple-50 border-purple-200 text-purple-700 dark:bg-purple-900/20 dark:border-purple-800 dark:text-purple-400";
        case "visitor":
        case "reserved":
        case "visitor / reserved":
            return "bg-yellow-50 border-yellow-200 text-yellow-700 dark:bg-yellow-900/20 dark:border-yellow-800 dark:text-yellow-400";
        case "blocked":
            return "bg-red-50 border-red-200 text-red-700 dark:bg-red-900/20 dark:border-red-800 dark:text-red-400";
        case "maintenance":
            return "bg-gray-50 border-gray-200 text-gray-700 dark:bg-gray-900/20 dark:border-gray-800 dark:text-gray-400";
        default:
            return "bg-gray-50 border-gray-200 text-gray-700 dark:bg-gray-900/20 dark:border-gray-800 dark:text-gray-400";
    }
};

const SlotCard = ({ slot, isSelected, onClick, className = "", isStacked = false }) => {
    const cardStyles = getStatusCardStyles(slot.status);

    if (isStacked) {
        // Stacked slots have a different design (horizontal layout within the group)
        return (
            <div
                onClick={() => onClick(slot)}
                className={`flex items-center justify-between p-2 mb-2 last:mb-0 rounded-lg border cursor-pointer transition-all duration-200 
                    ${isSelected
                        ? "shadow-sm ring-2 ring-blue-500"
                        : "hover:shadow-sm hover:-translate-y-0.5"
                    } ${cardStyles} ${className}`}
            >
                <span className={`text-[10px] font-bold tracking-wide uppercase`}>
                    {slot.levelName || "LEVEL"}
                </span>
                <div className="flex items-center gap-1.5">
                    {isSelected && <FontAwesomeIcon icon={faCheckCircle} className="text-blue-600 text-[12px]" />}
                    <span className="text-[9px] font-bold uppercase tracking-wider opacity-80">
                        {slot.status} {slot.rentalStatus === 'Rented' ? '(Rented)' : ''}
                    </span>
                </div>
            </div>
        );
    }

    // Standard slot layout (square)
    return (
        <div
            onClick={() => onClick(slot)}
            className={`relative flex flex-col items-center justify-center rounded-xl border-2 transition-all duration-200 cursor-pointer 
                ${isSelected
                    ? "shadow-md ring-2 ring-offset-1 ring-blue-500"
                    : "hover:shadow-md hover:-translate-y-0.5"
                } ${cardStyles} ${className}`}
            style={{ width: "86px", height: "86px" }}
        >
            {isSelected && (
                <div className="absolute -top-1.5 -right-1.5 bg-white dark:bg-dashboardbg rounded-full shadow-sm">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-blue-500 text-sm" />
                </div>
            )}
            <span className={`text-[12px] font-extrabold mb-1`}>
                {slot.slotNumber}
            </span>
            <span className="text-[9px] font-bold uppercase tracking-wider opacity-80 text-center leading-tight px-1 flex flex-col gap-0.5">
                <span>{slot.status}</span>
                {slot.rentalStatus === 'Rented' && (
                    <span className="text-[8px] bg-white/30 dark:bg-black/20 rounded px-1 py-0.5 mt-0.5 border border-current opacity-90">RENTED</span>
                )}
            </span>
        </div>
    );
};

export default SlotCard;
